/**
 * Date-extensions locale Faroese [fo]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('fo', {
    monthNames: ['Januar','Februar','Mars','Apríl','Mai','Juni','Juli','August','September','Oktober','November','Desember'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Des'],
    dayNames: ['Sunnudagur','Mánadagur','Týsdagur','Mikudagur','Hósdagur','Fríggjadagur','Leygardagur'],
    dayShortNames: ['Sun','Mán','Týs','Mik','Hós','Frí','Ley']
});
